<template>
  <div class="w-16 md:w-60 bg-white"></div> 
  <!-- Spacer -->
  <aside class="z-30 h-screen fixed">
    <div
      class="flex flex-col items-center h-full text-gray-700 bg-white rounded" 
    >
      <!-- Logo -->
      <RouterLink class="flex w-full px-2 items-center justify-start mt-5" to="/">
        <img
          src="/img/logo-icon-jobifull.png"
          alt="logo jobifull"
          class="w-12 cursor-pointer"
          @click="requestHandler.redirect('/')" 
        />
      </RouterLink>
      <!-- Menu lateral Options, toggleable -->
      <div
        :class="[
          isOpen ? 'w-48' : 'w-16',
          'md:w-48 h-full flex flex-col items-start px-2 mt-3transition-all duration-300 ',
        ]"
      >
        <div class="flex flex-col items-center mt-3 md:hidden">
          <!-- Toggle button -->
          <button
            class="flex items-center justify-center w-12 h-12 mt-2 rounded hover:bg-gray-300"
            @click="toggleMenu"
          >
            <i class="pi pi-bars" style="font-size: 1.3rem"></i>
          </button>
        </div>
        <div class="w-full overflow-x-hidden overflow-y-auto scrollbar">
          <!-- Options from Options array -->
          <div v-for="option in options" :key="option.id" class="w-full">
          <RouterLink
            :to="option.slug == 'jobs' ? '/jobs':`/dashboard/${userType}/${slug}/${option.slug}`"
            class="flex flex-row items-center justify-start w-full h-12 mt-2 px-3 rounded hover:bg-gray-300 overflow-hidden"
            @click="isOpen = false"
          >
            <i :class="option.icon" style="font-size: 1.3rem"></i>
            <div :class="[isOpen ? 'block md:block' : 'hidden md:block', 'ml-2 text-sm font-medium overflow-hidden text-nowrap']">
              {{ translate(option.label, 'ucfirst') }}
            </div>
          </RouterLink>
        </div>
        
        </div>
      </div>
      <!-- Profile settings -->
      <RouterLink
        :to="`/dashboard/${userType}/${slug}/profile`"
        class="flex items-center justify-center w-full h-16 mt-auto bg-sea-serpent hover:bg-oxford-blue"
      >
        <svg
          class="w-6 h-6 stroke-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </RouterLink>
    </div>
  </aside>
</template>

<script setup>
import { computed } from "vue";
import { RouterLink } from "vue-router";
import { useStore } from "vuex";
import { ref, watch } from "vue";
import requestHandler from "@/composables/requestHandler";
import { translate } from "@/composables/translate";
const options = ref([]);



const store = useStore();
let slug = store.getters.getUserSlug;
let userType = computed(() => store.getters.getLoggedAs);
let isOpen = ref(true);

function menuOptionsSet() {
  switch (store.getters.getLoggedAs) {
    case "company":
      options.value = [
        {
          id: 1,
          slug: "",
          icon: "pi pi-home",
          label: "Painel",
        },
        {
          id: 2,
          slug: "jobs",
          icon: "pi pi-briefcase",
          label: "Jobs",
        },
        {
          id: 3,
          slug: "post-job",
          icon: "pi pi-pen-to-square",
          label: "Create Job",
        },
        {
          id: 4,
          slug: "manage-recruiters",
          icon: "pi pi-users",
          label: "Recruiters",
        },
        {
          id: 5,
          slug: "messages",
          icon: "pi pi-comments",
          label: "Messages",
        }
      ];
      break;
    case "professional":
      options.value = [
        // {
        //   id: 1,
        //   slug: "",
        //   icon: "pi pi-home",
        //   label: "painel",
        // },
        {
          id: 2,
          slug: "jobs-application",
          icon: "pi pi-briefcase",
          label: "my applications",
        }, 
        {
          id: 4,
          slug: "preview/curriculum",
          icon: "pi pi-copy",
          label: "my curriculum",
        },
        {
          id: 5,
          slug: "jobs",
          icon: "pi pi-briefcase",
          label: "find work",
        },
      ];
      break;
    case "recruiter":
      options.value = [
        {
          id: 1,
          slug: "",
          icon: "pi pi-home",
          label: "panel",
        },
        {
          id: 2,
          slug: "jobs",
          icon: "pi pi-briefcase",
          label: "find Job",
        },
        {
          id: 3,
          slug: "post-job",
          icon: "pi pi-pen-to-square",
          label: "create Job"
        },
        {
          id: 4,
          slug: "manage-companies",
          icon: "pi pi-building",
          label: "companies",
        },       
      ];
      break;
    default:
      options.value = [
        {
          id: 1,
          slug: "home",
          icon: "pi pi-home",
        },
      ];
  }
}
function toggleMenu() {
  console.log(isOpen.value);
  isOpen.value = !isOpen.value;
}

menuOptionsSet();
watch(
  () => store.getters.getLoggedAs,
  () => {
    menuOptionsSet();
  })
</script>

<style scoped>
  .scrollbar{
    scrollbar-width: thin;
    scrollbar-color: #ccc #f1f1f1;
    }
  .scrollbar::-webkit-scrollbar {
    display: none !important; 
  }
  .scrollbar::-webkit-scrollbar-track {
    background-color: #f1f1f1;

  }
  .scrollbar::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
    
  }
  .scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
</style>
